import { selectorFamily } from 'recoil';
import { disputeSummaries, marDisputeTypes } from 'state';
import { MarDisputeType } from 'types';

export const filteredMarDisputeTypes = selectorFamily<MarDisputeType[], string>({
    key: 'filteredMarDisputeTypes',
    get: (accountId) =>
        ({ get }) => {
        const disputeTypes = get(marDisputeTypes);
        const disputes = get(disputeSummaries({ accountId }));

        return disputeTypes.filter(({ marDisputeTypeId }) => disputes.find(dispute => dispute.marDisputeTypeId === marDisputeTypeId));
    }
});
